import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Grid, useTheme } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { LoginDomainService } from '../login/loginDomainService';
import { di } from '../../state/inversify.config';
import { OnboardingDesktop } from '../login/components/smart/onBoardingDesktop.smart';
import { ConneqtLogo } from '../../components/logo/logo';
import { Banner } from '../../components/banner/banner';
import { SignUpWithConsent } from './signUpWithConsent';

export function SignUp() {
  const { t } = useTranslation();
  const theme = useTheme();

  const loginDomainService = di.get<LoginDomainService>(LoginDomainService);
  const isNetworkConnected = loginDomainService.useNetworkSelector();

  return (
    <Grid
      display="flex"
      flexDirection="row"
      justifyContent="center"
      sx={{
        background: theme.palette.background.default,
      }}
      pt={20}
    >
      <Grid
        display="flex"
        flexDirection="column"
        alignItems="center"
        sx={{ height: '100vh' }}
      >
        <ConneqtLogo />
        {!isNetworkConnected && (
          <Banner
            title={t('OFFLINE_MODE')}
            severity="error"
            icon={<WarningIcon />}
          />
        )}

        <Box sx={{ mx: 2 }}>
          <Typography
            component="h1"
            variant="h6"
            fontWeight="bold"
            sx={{
              color: theme.palette.text.primary,
            }}
          >
            {t('SIGN_UP_WELCOME_TITLE')}
          </Typography>

          <Typography
            variant="subtitle2"
            letterSpacing={0.5}
            sx={{
              color: theme.palette.text.primary,
            }}
          >
            {t('SIGN_UP_WELCOME_DESCRIPTION')}
          </Typography>

          <SignUpWithConsent />
        </Box>
      </Grid>

      <Grid
        sx={{
          width: '50%',
          display: { xs: 'none', sm: 'none', md: 'block' },
        }}
      >
        <OnboardingDesktop />
      </Grid>
    </Grid>
  );
}
